import { TPannellumConfig } from '../../types/panellum';
import { publicPath } from '../../utils';

const basePath = 'https://static.treedis.com/projects/avram';

export const pannellumConfigAvram: { [key: number]: TPannellumConfig } = {
  1: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/1`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'jpg',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hfov: 110,
    pitch: -15,
    hotSpots: [
      // Building hotspots
      {
        pitch: -15,
        yaw: -32,
        type: 'info',
        createTooltipArgs: { title: 'S1', type: 'building' },
      },
      {
        pitch: -16,
        yaw: -24,
        type: 'info',
        createTooltipArgs: { title: 'S2', type: 'building' },
      },
      {
        pitch: -17,
        yaw: -8,
        type: 'info',
        createTooltipArgs: { title: 'S3', type: 'building' },
      },
      {
        pitch: -17,
        yaw: 7,
        type: 'info',
        createTooltipArgs: { title: 'S4', type: 'building' },
      },
      {
        pitch: -16,
        yaw: 23,
        type: 'info',
        createTooltipArgs: { title: 'S5', type: 'building' },
      },
      {
        pitch: -15,
        yaw: 31,
        type: 'info',
        createTooltipArgs: { title: 'S6', type: 'building' },
      },
      {
        pitch: -6,
        yaw: -44,
        type: 'info',
        createTooltipArgs: { title: 'M2', type: 'building' },
      },
      {
        pitch: -6,
        yaw: 44,
        type: 'info',
        createTooltipArgs: { title: 'M3', type: 'building' },
      },
      // POI hotspots
      // library
      {
        pitch: 0.11360049027597796,
        yaw: 8.643716549638953,
        type: 'info',
        createTooltipArgs: {
          title: 'בית ספר טכנולוגי',
          stem: 50,
          type: 'poi',
          cardDescription: 'מוסד לימודים',
          cardImageSrc: publicPath('/images/shviro/card/library.webp'),
          transportation: { car: 2, walk: 5, bicycle: 3 },
        },
      },
      // city
      {
        pitch: 4.8873221286570585,
        yaw: 90.79692891011052,
        type: 'info',
        createTooltipArgs: {
          title: 'נהריה',
          stem: 50,
          type: 'poi',
          cardDescription: 'עיר מרכזית בישראל',
          cardImageSrc: publicPath('/images/shviro/card/city.webp'),
          transportation: { car: 15 },
        },
      },
      // sea
      {
        pitch: 0.8532397284929703,
        yaw: -106.60399953417516,
        type: 'info',
        createTooltipArgs: {
          title: 'חיפה',
          stem: 50,
          type: 'poi',
          cardDescription: 'מטרופולין',
          cardImageSrc: publicPath('/images/shviro/card/sea.webp'),
          transportation: { car: 30 },
        },
      },
      // bus
      {
        pitch: -2.275718916841136,
        yaw: -154.43544452690833,
        type: 'info',
        createTooltipArgs: {
          title: 'מטרונית',
          stem: 50,
          type: 'poi',
          cardDescription: 'נגישות לתחבורה ציבורית',
          cardImageSrc: publicPath('/images/shviro/card/bus.webp'),
          transportation: { car: 3, walk: 10, bicycle: 6 },
        },
      },
      // church
      {
        pitch: 1.2969814501935313,
        yaw: 18.646252257181914,
        type: 'info',
        createTooltipArgs: {
          title: 'בית תרבות חדש',
          stem: 50,
          type: 'poi',
          cardDescription: 'מגוון אירועים לקהלי יעד שונים',
          cardImageSrc: publicPath('/images/shviro/card/church.webp'),
          transportation: { car: 2, walk: 5, bicycle: 3 },
        },
      },
      {
        pitch: 9.465559657799949,
        yaw: 2.2237101647830286,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 2',
          stem: 50,
          type: 'scene',
          sceneId: 2,
          imgSrc: publicPath('/images/shviro/hotspots/2.webp'),
        },
      },
    ],
  },
  2: {
    type: 'multires',
    multiRes: {
      basePath: `${basePath}/pano/multires/2`,
      path: '/%l/%s%y_%x',
      fallbackPath: '/fallback/%s',
      extension: 'webp',
      tileResolution: 512,
      maxLevel: 5,
      cubeResolution: 6360,
    },
    hfov: 90,
    pitch: -10,
    hotSpots: [
      // Building hotspots
      {
        pitch: -16.5,
        yaw: 25,
        type: 'info',
        createTooltipArgs: { title: 'S2', type: 'building' },
      },
      {
        pitch: -15,
        yaw: 35,
        type: 'info',
        createTooltipArgs: { title: 'S1', type: 'building' },
      },
      {
        pitch: -18,
        yaw: -7,
        type: 'info',
        createTooltipArgs: { title: 'S4', type: 'building' },
      },
      {
        pitch: -17,
        yaw: -24,
        type: 'info',
        createTooltipArgs: { title: 'S5', type: 'building' },
      },
      {
        pitch: -18,
        yaw: 8,
        type: 'info',
        createTooltipArgs: { title: 'S3', type: 'building' },
      },
      {
        pitch: -15,
        yaw: -36,
        type: 'info',
        createTooltipArgs: { title: 'S6', type: 'building' },
      },
      {
        pitch: -4,
        yaw: 26,
        type: 'info',
        createTooltipArgs: { title: 'M2', type: 'building' },
      },
      {
        pitch: -4,
        yaw: -27,
        type: 'info',
        createTooltipArgs: { title: 'M3', type: 'building' },
      },
      // Scene transition hotspot
      {
        pitch: 10.267934476061944,
        yaw: 0,
        type: 'scene',
        createTooltipArgs: {
          title: 'תצפית 1',
          stem: 50,
          type: 'scene',
          sceneId: 1,
          imgSrc: publicPath('/images/shviro/hotspots/1.webp'),
        },
      },
      // POI hotspots
      // library
      {
        pitch: -1.1591584433748419,
        yaw: 174.88617421096637,
        type: 'info',
        createTooltipArgs: {
          title: 'בית ספר טכנולוגי',
          stem: 50,
          type: 'poi',
          cardDescription: 'מוסד לימודים',
          cardImageSrc: publicPath('/images/shviro/card/library.webp'),
          transportation: { car: 2, walk: 5, bicycle: 3 },
        },
      },
      // church
      {
        pitch: -3.6875586069006836,
        yaw: -176.64178388303526,
        type: 'info',
        createTooltipArgs: {
          title: 'בית תרבות חדש',
          stem: 50,
          type: 'poi',
          cardDescription: 'מגוון אירועים לקהלי יעד שונים',
          cardImageSrc: publicPath('/images/shviro/card/church.webp'),
          transportation: { car: 2, walk: 5, bicycle: 3 },
        },
      },
      // bus
      {
        pitch: -0.6465061805190145,
        yaw: 10.16408416533875,
        type: 'info',
        createTooltipArgs: {
          title: 'מטרונית',
          stem: 50,
          type: 'poi',
          cardDescription: 'נגישות לתחבורה ציבורית',
          cardImageSrc: publicPath('/images/shviro/card/bus.webp'),
          transportation: { car: 3, walk: 10, bicycle: 6 },
        },
      },
      // sea
      {
        pitch: 3.8974614687440887,
        yaw: 74.02622702718281,
        type: 'info',
        createTooltipArgs: {
          title: 'חיפה',
          stem: 50,
          type: 'poi',
          cardDescription: 'מטרופולין',
          cardImageSrc: publicPath('/images/shviro/card/sea.webp'),
          transportation: { car: 30 },
        },
      },
      // city
      {
        pitch: 5.039428256745335,
        yaw: -100.06326553102997,
        type: 'info',
        createTooltipArgs: {
          title: 'נהריה',
          stem: 50,
          type: 'poi',
          cardDescription: 'עיר מרכזית בישראל',
          cardImageSrc: publicPath('/images/shviro/card/city.webp'),
          transportation: { car: 15 },
        },
      },
    ],
  },
};
